import { Colors } from '@zapier/design-system';
import { AppsSectionProps } from './AppsSection';

export const DEFAULT_VALUES: AppsSectionProps = {
  apps: [
    {
      appProfileUrl: '/apps/gmail/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/54f0bd6f9c31b757ab20d4c7058dc7c0.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Gmail',
    },
    {
      appProfileUrl: '/apps/shopify/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/4da9d3e3f93cd522f85e1b0695341f89.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Shopify',
    },
    {
      appProfileUrl: '/apps/slack/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Slack',
    },
    {
      appProfileUrl: '/apps/google-calendar/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/62c82a7958c6c29736f17d0495b6635c.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Google Calendar',
    },
    {
      appProfileUrl: '/apps/mailchimp/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/221770b81f376004aee4a712ef4353be.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Mailchimp',
    },
    {
      appProfileUrl: '/apps/trello/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/da3ff465abd3a3e1b687c52ff803af74.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Trello',
    },
    {
      appProfileUrl: '/apps/asana/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/986718c45d823ca0a4173ec68912416e.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Asana',
    },
    {
      appProfileUrl: '/apps/hubspot/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'HubSpot',
    },
    {
      appProfileUrl: '/apps/zoom/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/472b2b8aba2dc38d4ef605c955341739_6.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Zoom',
    },
    {
      appProfileUrl: '/apps/stripe/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/27f5433f521806493e2c38a304e1786e.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Stripe',
    },
    {
      appProfileUrl: '/apps/marketo/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/bec09826ed23eb439c1d9f47d2f5fab7.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Marketo',
    },
    {
      appProfileUrl: '/apps/facebook-pages/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Facebook Pages',
    },
    {
      appProfileUrl: '/apps/google-drive/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/bb735e567f1a1e9e3b8b7241497c2d43.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Google Drive',
    },
    {
      appProfileUrl: '/apps/salesforce/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/1a4435539b4764e6ded3d368cabab387.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Salesforce',
    },
    {
      appProfileUrl: '/apps/zendesk/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/45e89018e756b043d806701f17dc2632.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Zendesk',
    },
    {
      appProfileUrl: '/apps/airtable/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/c6c8c5e300ef0da0e47b3084e5522f20.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Airtable',
    },
    {
      appProfileUrl: '/apps/microsoft-teams/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/22d6681f64c79dd71a34066afe1c54e2.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Microsoft Teams',
    },
    {
      appProfileUrl: '/apps/calendly/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Calendly',
    },
    {
      appProfileUrl: '/apps/jira/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/ea4a5ee38c7a088e243745dd0b851784.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Jira Software Server',
    },
    {
      appProfileUrl: '/apps/docusign/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/8b4a1cdb476943811b60b1adaf85fb4d.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'DocuSign',
    },
    {
      appProfileUrl: '/apps/google-sheets/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Google Sheets',
    },
    {
      appProfileUrl: '/apps/notion/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Notion',
    },
    {
      appProfileUrl: '/apps/microsoft-outlook/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/17b8fae71a30cf910b73ed0eda8b1443.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Microsoft Outlook',
    },
    {
      appProfileUrl: '/apps/twitter/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/580b3c79622bbff634f0d764e9f813a3.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Twitter',
    },
    {
      appProfileUrl: '/apps/discord/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/ca03beabe94d8f97ba6fbf75cbb695c4.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Discord',
    },
    {
      appProfileUrl: '/apps/clickup/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/services/000c15b838d86d80869cff5938fa76f3.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'ClickUp',
    },
    {
      appProfileUrl: '/apps/webflow/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/dba91ada3f465bc866a1c4431236d9f2_2.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Webflow',
    },
    {
      appProfileUrl: '/apps/pipedrive/integrations',
      iconUrl:
        'https://zapier-images.imgix.net/storage/developer/a70589f8db6a514b6820267b506409f0.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50',
      name: 'Pipedrive',
    },
  ],
  body:
    '<p>Zapier supports more apps than any other platform, so you can connect the tools you use today—and tomorrow.</p>',
  ctaText: 'Explore by app',
  ctaUrl: '#',
  heading: `<span style="color: ${Colors.zapier}">4,000+ apps,</span> infinite possibilities`,
};
